 /**
 * Time Length formatter
 * Calculate total millisecond time and return as HH:MM:SS format
 * @param  {Number} duration  Total time in milliseconds.
 * @return {String}     Formatted of time length.
 */

export const timeLengthFormat = (duration) => {

   if(duration !== null && duration !== 'undefined' ){
     let
       //milliseconds = parseInt((duration % 1000) / 100),
       seconds = parseInt((duration / 1000) % 60)
       , minutes = parseInt((duration / (1000 * 60)) % 60)
       , hours = parseInt((duration / (1000 * 60 * 60)) % 24);

     hours = (hours < 10) ? "0" + hours : hours;
     minutes = (minutes < 10) ? "0" + minutes : minutes;
     seconds = (seconds < 10) ? "0" + seconds : seconds;

     // return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
     return hours + ":" + minutes + ":" + seconds;// + "." + milliseconds;
   }else{
     return '0';
   }
};

 /**
  * Time To Millisecond
  * Convert minute and second to millisecond
  * @param  {Number} minute  Minute to convert.
  * @param  {Number} second  second to convert.
  * @return {Number} millisecond after convert.
  */
export const timeToMillisecond = (minute,second) => {
  let millisecond = 0;

  if(typeof minute == 'number'){
    millisecond += minute * (1000 * 60);
  }
  if(typeof second == 'number'){
    millisecond += second * 1000;
  }

  return millisecond;
};

 /**
  * Convert Millisecond to Minute
  * Calculate total time and return as MM format
  * @param  {Number} duration  Total time in milliseconds.
  * @return {String}     Formatted of time length.
  */

 export const millisecondToMinute = (duration) => {

   if(duration !== null && duration !== 'undefined' ){
     let minutes = parseInt((duration / (1000 * 60)) % 60);

     minutes = (minutes < 10) ? "0" + minutes : minutes;

     return minutes
   }else{
     return '';
   }
 };

 /**
  * Convert Millisecond to Second
  * Calculate total time and return as SS format
  * @param  {Number} duration  Total time in milliseconds.
  * @return {String}     Formatted of time length.
  */

 export const millisecondToSecond = (duration) => {

   if(duration !== null && duration !== 'undefined' ){
     let seconds = parseInt((duration / 1000) % 60);

     seconds = (seconds < 10) ? "0" + seconds : seconds;

     return seconds;
   }else{
     return '';
   }
 };

 /**
  * Time Length formatter
  * Calculate total second time  and return as HH:MM:SS format
  * @param  {Number} duration  Total time in second.
  * @return {String}     Formatted of time length.
  */

 export const secondToHHMMSSFormat = (duration) => {

   if(duration !== null && duration !== 'undefined' ){

     /*let measuredTime = new Date(null);
     measuredTime.setSeconds(duration); // specify value of SECONDS
     return measuredTime.toISOString().substr(11, 8);*/
     let
       //milliseconds = parseInt((duration % 1000) / 100),
       seconds = parseInt(duration % 60)
       , minutes = parseInt((duration / 60) % 60)
       , hours = parseInt((duration / (60 * 60)));


     hours = (hours < 10) ? "0" + hours : hours;
     minutes = (minutes < 10) ? "0" + minutes : minutes;
     seconds = (seconds < 10) ? "0" + seconds : seconds;

     // return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
     return hours + ":" + minutes + ":" + seconds;// + "." + milliseconds;
   }else{
     return '0';
   }
 };
 export const secondToMMMFormat = (duration) => {

   if(duration !== null && duration !== 'undefined' ){
     return parseInt(duration / 60).toFixed(0)
   }else{
     return '0';
   }

 };
